module.exports = __webpack_public_path__ + "static/media/1-ano.3fffab0d.png";